import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import * as moment from 'moment-timezone';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { sweetAlert } from 'src/app/utils/swal';
import { exportToCsv, getBrokersList, getstandingOrderDaysAsObject } from 'src/app/utils/utils.common';
import { DatePipe } from 'src/app/pipe/date-pipe/date.pipe';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { Router, ActivatedRoute } from '@angular/router';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';

@Component({
  selector: 'app-standing-orders-v2',
  templateUrl: './standing-orders-v2.component.html',
  styleUrls: ['./standing-orders-v2.component.css']
})
export class StandingOrdersV2Component implements OnInit, OnDestroy {
  standingOrderDays = getstandingOrderDaysAsObject();
  search: any;
  todayDate;
  timeZone;
  user;
  dataList = [];
  editTripModalObj;
  editTaxiRideModalObj;
  trip;
  corporateUsers = [];
  cloneTripModalObj;
  standingDetailModalObj;
  status = 'active';
  isShowDaysDropdown = false;
  standingOrders;
  columnsSortOrder: any = {
    milage: '',
    preSpecialRate: '',
    scheduleTime: '',
    appointmentTime: '',
    patient: ''
  }
  standingDays = [
    { label: 'Sun', value: 0, isChecked: true },
    { label: 'Mon', value: 1, isChecked: true },
    { label: 'Tue', value: 2, isChecked: true },
    { label: 'Wed', value: 3, isChecked: true },
    { label: 'Thu', value: 4, isChecked: true },
    { label: 'Fri', value: 5, isChecked: true },
    { label: 'Sat', value: 6, isChecked: true },
  ];

  preServiceAreas = {};
  preLevelOfServices = {};
  preSpaceTypes = {};
  isStandingOrderClone = false;
  selectedDropdownIndex = -1;
  toggleActionButtons = false;
  tripLogObj;

  constructor(
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private dateP: DatePipe,
    private corporateService: CorporateService,
    private serviceArea: ServiceAreasService,
    private levelOfServiceService: LevelOfServiceService
    ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.timeZone = data.timeZone;
          this.user = data;
          this.todayDate = moment.tz(this.timeZone).startOf('day').toISOString();
          this.getCorporateUserList();
          this.getTrips();
        }
      });
  }

  getCorporateUserList() {
    this.assignTripService
      .getCorporateUserList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateUsers = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
      this.getServiceAreas();
  }

  getTrips() {
    this.assignTripService.getAssignManifestList({
      status: 'standing',
      isRecurring: this.status === 'active' ? true : false
    })
    .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.dataList = [];
        if (data) {
          this.standingOrders = data;
          this.dataList = data;
          this.dataList.forEach(s => {
            s.diffFromToday = 10;
            if (s.recurringEndDate) {
              const end = moment(s.recurringEndDate, 'YYYY-MM-DD').tz(this.timeZone);
              const now = moment(this.todayDate).tz(this.timeZone);
              s.diffFromToday = end.diff(now, 'days');
            }
            // Inject flag
            s.isAssigned = Array.isArray(s.recurringDays)
              ? s.recurringDays.some(d => d && d.driver)
              : false;
          });
          this.dataList.sort((a, b) => a.diffFromToday - b.diffFromToday);
        }
        const column = Object.keys(this.columnsSortOrder)
          .find(key => this.columnsSortOrder[key]);
        if (column) {
          this.columnsSortOrder[column] = this.columnsSortOrder[column] === 'asc' ? 'desc' : 'asc';
          this.sortTrips(column);
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  editTrip(assign) {
    if (this.cloneTripModalObj) return;
    if (this.standingDetailModalObj) return;
    if (this.isTaxiRide(assign)) {
      this.editTaxiRideModalObj = assign._id;
      return;
    }
    this.editTripModalObj = assign._id;
    this.trip = assign;

  }

  onEditTrip(event) {
    this.editTripModalObj = null;
    this.isStandingOrderClone = false;
    this.trip = null;
    this.getTrips();
  }

  onEditTaxiRide(event) {
    this.editTaxiRideModalObj = null;
    this.isStandingOrderClone = false;
    this.getTrips();
  }

  isTaxiRide(assign: any) {
    const fundingSource = assign.cooperate ? this.corporateUsers[assign.cooperate] : null;
    return !!(fundingSource && fundingSource.companyType === 'taxi');
  }

  getCorporateByID(id) {
    return this.corporateUsers[id];
  }

  brokerList(key?) {
    if (key) {
      return getBrokersList[key];
    }
    return getBrokersList;
  }

  openCloneModal(trip) {
    this.cloneTripModalObj = trip;
  }

  closeCloneTripModal(evt) {
    this.cloneTripModalObj = null;
  }

  openStandingDetailModal(trip) {
    this.standingDetailModalObj = trip;
  }

  closeStandingDetailModal(evt) {
    this.standingDetailModalObj = null;
  }

  onChangeDays(){
    let days = [];
    this.standingDays.forEach(d => {
      if (d.isChecked) {
        days.push(d.value);
      }
    });
    if (days.length === 0) {
      this.dataList = this.standingOrders;
      return;
    }

    this.dataList = this.standingOrders.filter(s => s.recurringDays.some(r => days.includes(r.day)))
  }

  onChangeStatus() {
    this.getTrips();
  }

  downloadReport() {
    const table = [
      [
        "Trip ID",
        "Member",
        "PU Time",
        "Apt Time",
        "Pickup",
        "Dropoff",
        "LOS",
        "Type",
        "Days",
        "Status",
        "End Date"
      ]
    ];

    for (let i = 0; i < this.dataList.length; i++) {
      const trip = this.dataList[i];

      let type = '';
      if(trip.jobType === 'cooperate') {
        if (trip.cooperate) {
          const corp = this.getCorporateByID(trip.cooperate);
          type = corp ? corp.displayName : "None"
        } else {
          type = "None";
        }
      } else {
        type = trip.companyType === "" ? "Cab Dispatch" : this.brokerList(trip.companyType);
      }

      let days = '';
      days = trip.recurringDays.map(r => {
        return this.standingOrderDays[r.day]
      });
      days = days && days.length ? days.toString() : '';

      const standingOrder = [
        trip.tripId,
        trip.priorityClient ? trip.priorityClient.displayName : "N/A",
        this.dateP.transform(trip.scheduleTime, "HH:mm"),
        this.dateP.transform(trip.appointmentTime, "HH:mm"),
        trip.jobOriginAddress,
        trip.jobDestinationAddress,
        trip.tripRequirement,
        type,
        days,
        trip.isRecurring ? "Active": "Inactive",
        trip.recurringEndDate ? this.dateP.transform(trip.recurringEndDate, "MM/DD/YYYY") : "N/A"
      ]
      table.push(standingOrder);
    }
    exportToCsv(`standing-orders-${ moment().format("MM-DD-YYYY")}.csv`, table);
  }

  toggleDaysDropdown() {
    this.isShowDaysDropdown = !this.isShowDaysDropdown
  }

  getServiceAreas(){
    this.serviceArea.getServiceAreas({status: 'active'})
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
      this.getLevelOfService();
    }

    getLevelOfService() {
      this.levelOfServiceService
        .getLevelOfServices({status: 'active'})
        .subscribe(data => {
          if (data) {
            this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        }, err => {
          sweetAlert("Error", err, "error", "Ok");
        });
        this.getSpaceTypes();
    }

    getSpaceTypes() {
      this.levelOfServiceService
        .getSpaceTypes({status: 'active'})
        .subscribe(data => {
          if (data) {
            this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        }, err => {
          sweetAlert("Error", err, "error", "Ok");
        });
    }

  showActionButtons(idx) {
    this.selectedDropdownIndex = idx;
    this.toggleActionButtons = true;
  }

  closeActionMenu(evt) {
    this.selectedDropdownIndex = -1;
    this.toggleActionButtons = false;
    }

  openStandingOrderCloneModal(assign){
    if(assign){
      this.isStandingOrderClone = true;
      if (this.isTaxiRide(assign)) {
        this.editTaxiRideModalObj = assign._id;
        return;
      }
      this.editTripModalObj = assign._id;
      console.log("Condition working");
    }
  }

  sortTrips(column: string, skipToggle: boolean = false) {
      if (!skipToggle) {
        Object.keys(this.columnsSortOrder).forEach(col => {
          if (col !== column) {
            this.columnsSortOrder[col] = '';
          }
        });

        if (!this.columnsSortOrder[column]) {
          this.columnsSortOrder[column] = 'asc';
        } else {
          this.columnsSortOrder[column] =
            this.columnsSortOrder[column] === 'asc' ? 'desc' : 'asc';
        }
      }

      const order = this.columnsSortOrder[column];

    this.dataList.sort((a: any, b: any) => {
        let valA = a[column] || 0;
        let valB = b[column] || 0;

        if (column === 'patient') {
          valA = ((a && a.priorityClient && a.priorityClient.displayName) || '').toLowerCase();
          valB = ((b && b.priorityClient && b.priorityClient.displayName) || '').toLowerCase();
        }

        if (column === 'scheduleTime' || column === 'appointmentTime') {
          valA = moment(valA).valueOf();
          valB = moment(valB).valueOf();
        }

        if (!isNaN(valA)) valA = Number(valA);
        if (!isNaN(valB)) valB = Number(valB);

        if (valA < valB) return order === 'asc' ? -1 : 1;
        if (valA > valB) return order === 'asc' ? 1 : -1;

        return 0;
      });
    }

  openTripLog(assign) {
    this.tripLogObj = assign;
    }

     addSpecialRates(data) {
    this.assignTripService
      .addSpecialRate(data)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.dataList.forEach((item, i) => {
              if (item._id === data._id) {
                this.dataList[i].preSpecialRate = data.preSpecialRate;
              }
            });

            // sweetAlert('Success', 'Trip Special Rate Added Successfully', 'success', 'OK');
          }
          this.closeActionMenu(null);
        },
        (err) => {
          sweetAlert("Error", err, "warning", "OK");
          this.closeActionMenu(null);
        }
      );
  }

  ngOnDestroy(): void {
  }
}
